export default "__VITE_ASSET__DLWyqL8G__"